function customAddToCart(form, event, btn) {
  event?.preventDefault();
  const formData = new FormData(form);
  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((res) => res.json())
    .then((data) => {
      console.log("Added to cart:", data);
      return fetch("/");
    })
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newDrawer = doc.querySelector(".cart-drawer__dialog");
      const currentDrawer = document.querySelector(".cart-drawer__dialog");
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        // console.log("🛒 Cart drawer refreshed!");
        const newBubble = doc.querySelector(".cart-bubble");
        const currentBubble = document.querySelector(".cart-bubble");
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
        if (btn === "recommendation") {
          openCartDrawer();
        }
      } else {
        console.warn("Cart drawer DOM not found.");
      }
      let originalShippingHTML = null;
      function updateFreeShippingBar() {
        const cartTotalRaw = document.querySelector('.cart__total-container .cart__total__value')?.innerHTML;
        const cartTotal = parseFloat(cartTotalRaw?.replace(/[^0-9.]/g, '') || '0');
        const bar = document.querySelector('free-shipping-bar');
        if (!bar) return;
        const threshold = parseFloat(bar.getAttribute('threshold-amount'));
        const shippingText = bar.querySelector('.shipping_text');
        const shippingAmountEl = bar.querySelector('.shipping_amount');
        const progressBar = bar.querySelector('progress-bar');
        if (!shippingText || !shippingAmountEl || !progressBar || isNaN(threshold)) return;
        if (!originalShippingHTML) originalShippingHTML = shippingText.innerHTML;
        if (cartTotal >= threshold) {
          shippingText.innerHTML = bar.getAttribute('reached_text');
        } else {
          const remaining = (threshold - cartTotal).toFixed(2);
          shippingText.innerHTML = originalShippingHTML;
          shippingText.querySelector('.shipping_amount').textContent = `$${remaining}`;
        }
        let percent = (cartTotal / threshold) * 100;
        if (percent > 100) percent = 100;
        progressBar.style.setProperty('--progress', `${percent}%`);
      }
      setTimeout(updateFreeShippingBar, 500);
    })
    .catch((err) => console.error("Error updating cart drawer:", err));
}
function openCartDrawer() {
  const cartIcon = document.querySelector(".header-actions__cart-icon");
  if (cartIcon) {
    setTimeout(() => {
      cartIcon.click();
      // console.log("Drawer opened after refresh (recommendation)!");
    }, 150);
  }
}

document.addEventListener('DOMContentLoaded', () => {
    // @ts-ignore
    function runResults(event) {
      event.preventDefault();
      console.log('hi',event.target);
      if(event.target.classList.contains('storerocket-result-button-3660')){
        event.target.click();
      }

      const wrapper = document.querySelector('#storerocket-widget #storerocket-overlay');
      if (!wrapper) return;

      const name = wrapper.querySelector('.storerocket-overlay-details-name');
      const address = wrapper.querySelector('.storerocket-overlay-details-address');
      if (!name || !address) return;

      // Save only one object at a time in localStorage
      // @ts-ignore
      function saveToSession(dataObj) {
        const key = 'storeRocketData';
        localStorage.setItem(key, JSON.stringify({ ...dataObj, savedAt: Date.now() }));
        console.log('Replaced localStorage with:', dataObj);
      }
        const nameText = name.textContent.trim();
        const addressText = address.textContent.trim();
        const fieldsWrapper = wrapper.querySelector('.storerocket-overlay-fields');
        const fieldItems = fieldsWrapper?.querySelectorAll('.storerocket-overlay-fields-item');
        const fields = {};
        if (fieldItems) {
          fieldItems.forEach(item => {
            const key = item.querySelector('.storerocket-overlay-fields-item__name')?.textContent.trim();
            const value = item.querySelector('.storerocket-overlay-fields-item__value')?.textContent.trim();
            // @ts-ignore
            if (key && value) fields[key] = value;
          });
        }
        console.log(nameText, addressText, fields);
        if (nameText && addressText && Object.keys(fields).length > 0) {
          const data = {
            name: nameText,
            address: addressText,
            ...fields
          };
          console.log('Data object:', data);
          saveToSession(data);
          window.location.href = '/collections/shop-all'
          observer.disconnect();
        }
    }



  const observer = new MutationObserver(() => {
    let buttons = document.querySelectorAll('#storerocket-widget .storerocket-result-button.storerocket-result-button-3660,#storerocket-widget .storerocket-overlay-details-custom-ctas-item');
    buttons.forEach(button => button.addEventListener('click', runResults));
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


document.addEventListener('DOMContentLoaded', () => {
   // @ts-ignore
  function doesItemFit(container, data) {
    const type = container.dataset.type;

    const height = parseFloat(container.dataset.height || 0);
    const width  = parseFloat(container.dataset.width || 0);
    const depth  = parseFloat(container.dataset.depth || 0);

    const heightKey = `${type} Height`;
    const widthKey  = `${type} Width`;
    const depthKey  = `${type} Depth`;

    const storedHeight = parseFloat(data[heightKey] || 0);
    const storedWidth  = parseFloat(data[widthKey] || 0);
    let storedDepth    = parseFloat(data[depthKey]);

    const isTypeAllowed =
      String(data[type]).toLowerCase() === "true";

    if (type === "Solid" && (!data[depthKey] || isNaN(storedDepth)) && isTypeAllowed) {
      storedDepth = 100;
    }

    //console.log("Checking:", type, { height, width, depth, storedHeight, storedWidth, storedDepth, isTypeAllowed });

    return (
      isTypeAllowed &&
      height <= storedHeight &&
      width <= storedWidth &&
      depth <= storedDepth
    );
  }

  // A .dimensions_meta element only represents an actual bag when it has a
  // type AND a height/width set — some accessory products still get the
  // element rendered (e.g. only "dimensions" display text is set on the
  // metafield, with data-type/data-height left blank), so checking for the
  // element's mere presence isn't enough to know it's a real bag.
  // @ts-ignore
  function isBagMeta(meta) {
    return !!(meta && meta.dataset.type && meta.dataset.height);
  }

  const VENUE_SEARCH_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

  function checkAcceptedBags() {
    const stored = localStorage.getItem('storeRocketData');
    // console.log(stored);
    if (!stored) return;

    const data = JSON.parse(stored);

    if (!data.savedAt || Date.now() - data.savedAt > VENUE_SEARCH_TTL_MS) {
      localStorage.removeItem('storeRocketData');
      return;
    }

    const locationName = data.name;
    if (!locationName) return;

    /* ---------------------------
       PRODUCT GRID (Collection Page)
    --------------------------- */
      const cards = document.querySelectorAll('.custom_product_card');
      cards.forEach(card => {
        const meta = card.querySelector('.dimensions_meta');
        const tag = card.querySelector('.accepted_tag');
        const otherBadges = card.querySelector('.card__badge');
        // Non-bag items (straps, charms, etc.) have no real dimension data, so
        // the venue bag-fit filter never applies to them — leave untouched.
        if (!isBagMeta(meta) || !tag) return;

        if(window.location.href.includes('collections/shop-all')) {
          if(card.closest('.product-grid__item')){
            card.closest('.product-grid__item').style.display = 'none';
          }
        };

        const fits = doesItemFit(meta, data);

        tag.style.display = fits ? 'flex' : 'none';
        otherBadges.style.display = fits ? 'none' : 'flex';
        if (fits) {
          const textEl = tag.querySelector('.accepted_tag_text');
          if (textEl) textEl.textContent = `Accepted at ${locationName}`;
          if(window.location.href.includes('collections/shop-all')) {
            if(card.closest('.product-grid__item')){
              card.closest('.product-grid__item').style.display = 'block';
            }
          };
        }
      });

    /* ---------------------------
       COLLECTION PAGE INFO SECTION
    --------------------------- */

    const mainWrapper = document.querySelector('.sp__button_links');
  const mainCollection = document.querySelector('.main__collection');
  const buttons = document.querySelectorAll('.main__collection .sp__button_links .first_two_button span');
  const allCards = document.querySelectorAll('.main__collection .product-grid__item');

  if (mainWrapper && mainCollection && buttons.length > 0) {
  mainWrapper.classList.add('active');
  mainCollection.classList.add('active');

  function setActiveButton(clickedBtn) {
    buttons.forEach(btn => btn.classList.remove('active'));
    clickedBtn.classList.add('active');
  }

  function filterAcceptedCards() {
    allCards.forEach(card => {
      const meta = card.querySelector('.dimensions_meta');
      const acceptedTag = card.querySelector('.accepted_tag');

      // Non-bag items (straps, charms, etc.) have no real dimension data to
      // evaluate against the venue's bag policy, so they're never subject
      // to this filter and always stay visible.
      if (!isBagMeta(meta)) {
        card.style.display = '';
        return;
      }

      if (acceptedTag && window.getComputedStyle(acceptedTag).display === 'flex') {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  }

  function showAllCards() {
    allCards.forEach(card => {
      card.style.display = '';
    });
  }

  function applyFilter(type) {
    if (type === 'all') {
      setActiveButton(buttons[1]);
      showAllCards();
    } else {
      setActiveButton(buttons[0]);
      filterAcceptedCards();
    }
  }

  // Click Events
  buttons.forEach((button, index) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const filterType = index === 0 ? 'accepted' : 'all';

      sessionStorage.setItem('collectionFilter', filterType);
      applyFilter(filterType);
    });
  });

  // On Load → restore previous state
  const savedFilter = sessionStorage.getItem('collectionFilter') || 'accepted';
  applyFilter(savedFilter);



    const collectionSearchResult = mainWrapper?.querySelector('.section__wrapper_search_result');
    if (collectionSearchResult) {
     // @ts-ignore
      collectionSearchResult.querySelector('.result_name').textContent = data.name || '';
     // @ts-ignore
      collectionSearchResult.querySelector('.result_address').textContent = data.address || '';
     // @ts-ignore
      collectionSearchResult.querySelector('.result_bag_policy').textContent = data["Bag Policy"] || '';
    }
  }

    /* ---------------------------
       PRODUCT PAGE
    --------------------------- */
    const productContainer = document.querySelector('.product_search_reult_container');
    if (productContainer) {
      const venue__search_wrapper = document.querySelector('.venue__search_wrapper');
      const fits = doesItemFit(productContainer, data);
      if (fits) {
       // @ts-ignore
        productContainer.style.display = 'flex';
        const textEl = productContainer.querySelector('.product_search_reult_container_text');
        if (textEl) textEl.textContent = `Accepted at ${locationName}`;
      // @ts-ignore
        venue__search_wrapper.style.display = 'none';
      } else {
      // @ts-ignore
        productContainer.style.display = 'none';
     // @ts-ignore
        venue__search_wrapper.style.display = 'flex';
      }
    }

    /* ---------------------------
       CART ITEMS
    --------------------------- */
    const cartItems = document.querySelectorAll('.cart-items__table-row');
    cartItems.forEach(item => {
      const container = item.querySelector('.item_search_reult_container');
      if (!container) return;

      const fits = doesItemFit(container, data);
     // @ts-ignore
      container.style.display = fits ? 'flex' : 'none';
      if (fits) {
        const textEl = container.querySelector('.item_search_reult_container_text');
        if (textEl) textEl.textContent = `Accepted at ${locationName}`;
      }
    });
  }

  checkAcceptedBags();
  setInterval(checkAcceptedBags, 3000);
});


// @ts-ignore
window.clearSearchResults = function(ele) {
  localStorage.removeItem('storeRocketData');
  console.log('storeRocketData removed from session storage');
  window.location.reload();
};


document.addEventListener('DOMContentLoaded', () => {

  if (!window.location.href.includes('collections/all?location=')) return;

  let hasClicked = false;

  const observer = new MutationObserver(() => {
    const btn = document.querySelector(
      '.storerocket-result-button.storerocket-result-button-3660'
    );

    if (btn) {
      console.log("✅ Correct button found:", btn);
    } else {
      console.log("⏳ Waiting for correct button...");
    }

    if (btn && !hasClicked) {
      hasClicked = true;

      console.log("🚀 Auto clicking StoreRocket button...");
      
      // 👇 important: thoda delay do (UI ready hone ke liye)
      setTimeout(() => {
       btn.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      }, 200);

      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});
